import "./index.less";
import React from "react";
import { set } from "lodash";
import YxAction from "../YxAction";
import { Menu, Dropdown } from "antd";
import { defaulProps } from "./params";
import { YxComponent, Connection } from "../YxComponent";
import { get, merge, random, cloneDeep } from "../../utils";
import language, { findPackage } from "../../config/language";

/**
 * 多项input组件,此组件必须被form包住
 * 动态多语言组件（用于多种语种输入）
 * @class MultipleInput
 * @extends {YxComponent}
 */
@Connection(defaulProps)
class MultipleInput extends YxComponent {
  constructor(props, content) {
    super(props, content);
    this.state = {
      showId: get(
        this.props,
        "colItem.controlList[0].controlItemParam.id",
        null
      ),
      menuVisible: false,
    };
    this.id = random();
  }

  componentDidMount() {
    document.body.addEventListener("click", this.closeMenu);
  }

  componentWillUnmount() {
    document.body.removeEventListener("click", this.closeMenu);
  }

  closeMenu = (event) => {
    for (let dom of get(event, "path", [])) {
      if (dom.classList != null) {
        const extraList = ["yx_multiple_input_dr", "multiple_input_item"];
        const status = extraList.some((e) => dom.classList.contains(e));
        if (status) {
          return;
        }
      }
    }
    this.setState({ menuVisible: false });
  };

  /**
   * 渲染下拉菜单
   *
   * @memberof MultipleInput
   */
  menu = (controlList) => {
    const list = controlList.map((item) => {
      const id = get(item, "controlItemParam.id", "");
      const index = get(item, "index", 0);
      const package_ = findPackage(index);
      const placeholder = get(package_, "inputPlaceholder", "");
      const suffix = get(item, "env", "");
      const value = this.props.form.getFieldValue(id);
      const result = { id, value, text: placeholder, suffix };
      return result;
    });
    return (
      <Menu>
        {list.map((item, index) => {
          const action = () => this.itemClick(item);
          return (
            <Menu.Item key={index}>
              <YxAction
                onClick={action}
                text={get(item, ["value", "text"], "")}
                styleType="link"
              />
              <p className="suffix" onClick={action}>
                {item.suffix}
              </p>
            </Menu.Item>
          );
        })}
      </Menu>
    );
  };

  /**
   *渲染当前显示的文本
   *
   * @readonly
   * @memberof MultipleInput
   */
  get text() {
    const controlList = get(this.props, "colItem.controlList", []);
    const textDict = {};
    for (let item of controlList) {
      const key = get(item, "controlItemParam.id", "");
      const language = get(item, "language", "");
      textDict[key] = language;
    }
    return textDict[this.state.showId];
  }

  /**
   * 深度修改表单元素
   *
   * @param {*} controlList
   * @returns
   * @memberof MultipleInput
   */
  itemListCall(controlList) {
    return controlList.map((item_) => {
      const item = cloneDeep(item_);
      const show = get(item, "controlItemParam.id", "") === this.state.showId;
      const EnvDOM = (
        <div className="toggle_btn" onClick={this.toggleMenu}>
          {item.env}
        </div>
      );
      set(item, "controlItemParam.inputParam.addonAfter", EnvDOM);
      set(
        item,
        "controlItemParam.className",
        "multiple_input_item multiple_input_item_string"
      );
      return {
        ...item,
        cellParam: {
          className: show === true ? "show" : "hiddle",
          controltype: item.type,
        },
      };
    });
  }

  proctionHtml = () => {
    const controlList = get(this.props, "colItem.controlList", []);
    const itemList = this.itemListCall(controlList);
    const param = { ...get(this.props, "colItem", {}), controlList: itemList };
    const html = get(this.props, "fun", () => {})(param); // 限制于动态表单，所以必须在里面调用一次这个函数
    return html;
  };

  itemClick = (item) => {
    const id = item.id == null ? "" : item.id;
    this.setState({ showId: id });
    this.toggleMenu();
  };

  toggleMenu = () => {
    this.setState({ menuVisible: !this.state.menuVisible });
  };

  render() {
    const controlList = get(this.props, "colItem.controlList", []);
    const className = [get(this.props, "className", ""), "yx_multiple_input"];
    return (
      <div className={className.join(" ")} id={this.id}>
        {this.proctionHtml()}
        <Dropdown
          visible={this.state.menuVisible}
          overlay={this.menu(controlList)}
          overlayClassName="yx_multiple_input_dr"
        >
          <div className="placeholder"></div>
        </Dropdown>
      </div>
    );
  }
}

export default MultipleInput;



// WEBPACK FOOTER //
// ./src/yx-widget/component/MultipleInput/index.js